import React, { useState } from 'react';
import { UseFormGetValues, UseFormRegister } from 'react-hook-form';
import { Recreation } from '@/types';
import { RecreationAdditionalFacilityFeeForm } from './recreationAdditionalFacilityFeeForm';
import { RecreationEditMaterialAmount } from './recreationEditMaterialAmount';
import { RecreationEditAmount } from './recreationEditAmount';
import { RecreationMaterialAmount } from './recreationMaterialAmount';
import { RecreationFormValues } from './recreationNewForm';
import { RecreationAmount } from './recreationAmount';
import { RecreationIsWithholdingTax } from './recreationIsWithholdingTax';

const DESCRIPTION_PLACEHOLDER_TEXT = `交通費について
東京都 北区、豊島区０円
北区、豊島区以外の東京都内 500円
神奈川 1000円
千葉 1500円
埼玉 1500円
上記以外はご相談ください
` as const;

export const SecondStep: React.FC<{
  getValues: UseFormGetValues<RecreationFormValues>;
  register: UseFormRegister<RecreationFormValues>;
  recreation?: Recreation;
}> = ({ getValues, register, recreation }) => {
  const [extraInformation, setExtraInformation] = useState<string>(
    getValues('extraInformation')
  );

  const isShowAdditionalFacilityFee = recreation
    ? recreation.kind.key === 'online'
    : getValues('kind') === 'online';

  return (
    <div>
      {!recreation && <RecreationAmount register={register} />}
      {recreation && <RecreationEditAmount recreation={recreation} />}
      {!recreation && <RecreationMaterialAmount register={register} />}
      {recreation && <RecreationEditMaterialAmount recreation={recreation} />}
      {isShowAdditionalFacilityFee && (
        <RecreationAdditionalFacilityFeeForm
          mode={recreation ? 'edit' : 'new'}
          register={register}
          recreation={recreation}
        />
      )}
      {recreation && <RecreationIsWithholdingTax register={register} />}
      <div className='mt-4'>
        <h5 className='text-black font-weight-bold'>お借りしたいものを入力</h5>
      </div>
      <p className='small my-0'>
        レクに必要なものを施設から借りたい場合は入力してください
      </p>
      <input
        type='text'
        className='p-2 w-100 rounded border border-secondary'
        {...register('borrowItem')}
      />
      <div className='mt-4'>
        <h5 className='text-black font-weight-bold'>持ち込むものを入力</h5>
      </div>
      <p className='small my-0'>
        レクに必要なものを自前で施設に持ち込む場合は入力してください
      </p>
      <input
        type='text'
        className='p-2 w-100 rounded border border-secondary'
        {...register('bringYourOwnItem')}
      />
      <div className='mt-4'>
        <h5 className='text-black font-weight-bold'>その他を入力</h5>
      </div>
      <p className='small my-0'>
        交通費に関する補足や、サポート必要人数、注意事項やその他備考などありました入力してください
      </p>
      <textarea
        rows={15}
        className='p-1 w-100 rounded border border-secondary'
        placeholder={DESCRIPTION_PLACEHOLDER_TEXT}
        {...register('extraInformation', {
          maxLength: 500,
        })}
        onChange={(e) => setExtraInformation(e.target.value)}
        maxLength={500}
      />
      <p className='small my-0'>{extraInformation?.length}/500文字まで</p>
    </div>
  );
};
